// A stale dynamic import can fail when a deployment replaces the old asset.
// Reload at most once per 30 seconds, and never loop offline or without storage.
const STORAGE_KEY = 'sitescope:chunk-recovery';
const RETRY_WINDOW_MS = 30000;
export function installChunkRecovery(browser = window, now = Date.now) {
  const handler = event => {
    if (browser.navigator.onLine === false) return;
    try {
      const timestamp = now();
      const previous = Number(browser.sessionStorage.getItem(STORAGE_KEY));
      if (previous > 0 && timestamp - previous < RETRY_WINDOW_MS) return;
      browser.sessionStorage.setItem(STORAGE_KEY, String(timestamp));
      event.preventDefault();
      browser.location.reload();
    } catch { /* Leave the normal error path intact when storage is unavailable. */ }
  };
  browser.addEventListener('vite:preloadError', handler);
  return () => browser.removeEventListener('vite:preloadError', handler);
}
